import { useQuery } from '@apollo/client/react';
import { PageLoader } from '@optools/components/loading/page-loader';
import { Card } from '@optools/components/ui/card';
import { GET_MILESTONES } from '@optools/services/operator-gateway/milestones/queries';
import { differenceInSeconds } from 'date-fns';
import { useMemo } from 'react';

import { useMilestoneEditor } from '../context/milestone-editor-context';
import { MilestonesSlider } from './milestones-slider';
import { MilestonesTable } from './milestones-table';
interface MilestonesTabProps {
  mediaId: string;
}

export function MilestonesTab({ mediaId }: MilestonesTabProps) {
  const { duration, playbackUrlsLoading, programDateTime, videoLoading, videoRef } =
    useMilestoneEditor();

  const { data, loading } = useQuery(GET_MILESTONES, {
    fetchPolicy: 'cache-and-network',
    skip: !mediaId,
    variables: { mediaId },
  });

  const milestones = useMemo(() => {
    return (
      data?.milestones?.map((milestone) => {
        const videoTime = differenceInSeconds(milestone.absoluteTime, programDateTime);
        return { ...milestone, videoTime };
      }) ?? []
    );
  }, [data?.milestones, programDateTime]);

  if (playbackUrlsLoading) return <PageLoader />;

  const showSlider = duration && programDateTime && !videoLoading;

  return (
    <div className="mx-auto flex h-full max-w-[clamp(200px,100%,200vh)] flex-col pb-8">
      <div className="mt-2">
        <div className="flex h-full flex-col-reverse gap-2 md:grid md:grid-cols-2">
          <MilestonesTable
            loading={loading || videoLoading}
            mediaId={mediaId}
            milestones={milestones}
            programDateTime={programDateTime}
          />
          <Card className="flex h-[calc(100%-40px)] w-full self-end overflow-hidden rounded-md">
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video ref={videoRef} className="w-full object-cover" controls />
          </Card>
        </div>
      </div>

      {showSlider && (
        <MilestonesSlider
          duration={duration}
          mediaId={mediaId}
          milestones={milestones}
          programDateTime={programDateTime}
        />
      )}
    </div>
  );
}
